export default {
	code: [
		{
			code: '18',
			voucherType: 'Documentos Autorizados utilizados en ventas excepto N/C N/D',
			typeDocumentId: 15,
		},
		{
			code: '18',
			voucherType: 'Documentos Autorizados utilizados en ventas excepto N/C N/D COMPROBANTE DE RETENCIÓN',
			typeDocumentId: 18,
		},
		{
			code: '04',
			voucherType: 'Nota de Crédito',
			typeDocumentId: 19,
		},
		{
			code: '05',
			voucherType: 'Nota de Débito',
			typeDocumentId: 40,
		},
	],
};



// WEBPACK FOOTER //
// ./src/shared/codeTaxesSale.js